import React from 'react';

const HowToPlayContentRU: React.FC = () => {
  return (
    <div className="space-y-4 text-gray-700">
      <div className="bg-blue-50 p-4 rounded-2xl">
        <h3 className="font-bold text-blue-800 mb-2">🎯 Цель</h3>
        <p>Угадай, у кого какой номер, наблюдая за их игрой!</p>
      </div>

      <div className="bg-green-50 p-4 rounded-2xl">
        <h3 className="font-bold text-green-800 mb-2">👥 Игроки</h3>
        <p>Нужно 4-10 игроков. Один человек будет "угадывающим", а остальные получат секретные номера от 1 до 9.</p>
      </div>

      <div className="bg-orange-50 p-4 rounded-2xl">
        <h3 className="font-bold text-orange-800 mb-2">🎭 Как Играть</h3>
        <div className="space-y-2 text-sm">
          <p><strong>1.</strong> Угадывающий читает ситуацию вслух</p>
          <p><strong>2.</strong> Все остальные показывают свою реакцию на основе своего номера</p>
          <p><strong>3.</strong> Номер 1 = очень спокойно, Номер 9 = совершенно безумно!</p>
          <p><strong>4.</strong> Угадывающий наблюдает и пытается понять, у кого какой номер</p>
        </div>
      </div>

      <div className="bg-purple-50 p-4 rounded-2xl">
        <h3 className="font-bold text-purple-800 mb-2">🏆 Победа</h3>
        <p>Угадывающий получает очки за каждое правильное угадывание. Затем кто-то другой становится новым угадывающим!</p>
      </div>

      <div className="bg-yellow-50 p-4 rounded-2xl">
        <h3 className="font-bold text-yellow-800 mb-2">💡 Пример</h3>
        <p className="text-sm"><strong>Ситуация:</strong> "Вы видите паука в своей комнате"</p>
        <p className="text-sm">• Номер 1: Сохраняйте спокойствие, может быть, игнорируйте</p>
        <p className="text-sm">• Номер 9: Кричите и убегайте!</p>
      </div>
    </div>
  );
};

export default HowToPlayContentRU;